import { defineComponent } from "vue";
import EeasNavbar from "./components/eeas-navbar/EeasNavbar.vue";
import EeasFooter from "./components/eeas-footer/EeasFooter.vue";


export default defineComponent({
    name: "App",
    components: {
        EeasNavbar,
        EeasFooter
    }
});